import script from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeScanner.vue?vue&type=style&index=0&id=09947efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09947efa"]])

export default __exports__